import { render, staticRenderFns } from "./My.vue?vue&type=template&id=26a06af0&scoped=true&"
import script from "./My.vue?vue&type=script&lang=ts&"
export * from "./My.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a06af0",
  null
  
)

export default component.exports